import {Directive, ElementRef, Input, NgModule, OnDestroy, Renderer2, OnInit} from '@angular/core';
import { RestUrlsConfig, GenericConfig } from '@signature-it/ngx-generic/config';
import {ILanguage} from '@signature-it/ngx-generic/interfaces';
import {LanguageService} from '@signature-it/ngx-generic/services';

declare let _: any;
declare let $: any;
declare let self: any;

@Directive({
    selector: '[multi-lang-image]',
    standalone: false
})
export class MultiLangImageDirectiveGeneric implements OnInit, OnDestroy {
    @Input() src: any;
    lang: ILanguage;
	listenError: Function;
    CDNPrefix = GenericConfig.CDNPrefix || '';

    constructor(protected restUrlsConf: RestUrlsConfig,
                protected el: ElementRef,
                protected renderer: Renderer2,
				protected langSvc: LanguageService) {
    }

    ngOnInit(): void {
		this.langSvc
			.getCurrentLanguage$()
			.subscribe(lang => {
				this.lang = lang;
				const imgEl = this.el.nativeElement;
				this.renderer.setAttribute(imgEl, 'src', this.getImageForLang());
				const self = this;
				this.listenError = this.renderer.listen(imgEl, 'error', (e) => {
					let target = e.srcElement;
					if($(target).attr('src') !== self.getDefaultImage()) {
						self.renderer.setAttribute(target, 'src', self.getDefaultImage());
					}
				});
			});
    }

    getImageForLang(): string {
        let prefix = `.${this.src.split('.').pop()}`;
        return `${this.CDNPrefix}${this.src.replace(prefix, '' ,this.src)}_${this.lang.code}${prefix}`;
    }

    getDefaultImage() {
        return `${this.CDNPrefix}${this.src}`;
    }

    ngOnDestroy() {
        if(this.listenError instanceof Function) {
            this.listenError();
        }
    }

}

@NgModule({
    declarations: [MultiLangImageDirectiveGeneric],
    exports: [MultiLangImageDirectiveGeneric]
})
export class MultiLangImageDirectiveModuleGeneric {}
